import React from "react";
import {
  BarChart3,
  User,
  CreditCard,
  Settings,
  Lock,
  HelpCircle,
} from "lucide-react";
import { useDispatch } from "react-redux";
import { useTranslation } from "../../../contexts/I18nProvider";
import { useTheme } from "../../../contexts/ThemeContext";
import { setActiveSection } from "../../../redux/slices/profileSlice";
import styles from "./ProfileSidebar.module.css";
import NavItem from "./common/NavItem";

const ProfileSidebar = ({ activeSection }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { isDark } = useTheme();

  const menuItems = [
    {
      id: "overview",
      label: t("pages.profile.sections.overview"),
      icon: BarChart3,
    },
    {
      id: "account",
      label: t("pages.profile.sections.account"),
      icon: User,
    },
    {
      id: "subscription",
      label: t("pages.profile.sections.subscription"),
      icon: CreditCard,
    },
    {
      id: "preferences",
      label: t("pages.profile.sections.preferences"),
      icon: Settings,
    },
    {
      id: "security",
      label: t("pages.profile.sections.security"),
      icon: Lock,
    },
    {
      id: "help",
      label: t("pages.profile.sections.help"),
      icon: HelpCircle,
    },
  ];

  const handleNavClick = (sectionId) => {
    dispatch(setActiveSection(sectionId));
  };

  return (
    <aside className={`${styles.sidebar} ${isDark ? styles.dark : ""}`}>
      <nav className={styles.nav}>
        {menuItems.map((item) => (
          <NavItem
            key={item.id}
            item={item}
            isActive={activeSection === item.id}
            onClick={() => handleNavClick(item.id)}
          />
        ))}
      </nav>
    </aside>
  );
};

export default ProfileSidebar;
